<template>
  <div ref="container">
    <div class="JMAjpe">
      <div class="p41dxb" aria-hidden="true">
        <div class="SvvLuf">
          <div class="pLn8M" style="background-color:#e0f7fa"></div>
          <div class="iNS9xc">0%</div>
        </div>
        <div class="SvvLuf">
          <div class="pLn8M" style="background-color:#b2ebf2"></div>
          <div class="iNS9xc">20%</div>
        </div>
        <div class="SvvLuf">
          <div class="pLn8M" style="background-color:#81d4fa"></div>
          <div class="iNS9xc">40%</div>
        </div>
        <div class="SvvLuf">
          <div class="pLn8M" style="background-color:#03a9f4"></div>
          <div class="iNS9xc">60%</div>
        </div>
        <div class="SvvLuf">
          <div class="pLn8M" style="background-color:#0288d1"></div>
          <div class="iNS9xc">&gt;80%</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "VaccinBar",
  props: {},
  data: () => ({}),
  computed: {},
  mounted: function() {},
  methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.JMAjpe {
  padding: 12px;
  font-family: Roboto-Regular, Helvetica Neue, Arial, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  direction: ltr;
  max-width: 300px;
  margin: auto;
}
.p41dxb {
  display: flex;
  padding: auto;
}
.SvvLuf {
  flex: 1;
}
.pLn8M {
    height: 8px;
}
.iNS9xc {
    line-height: 16px;
    color: #70757a;
}
</style>
